import type { TInterview } from '@/services/interviews';

import { useInterviewStarted } from './useInterviewStarted';

const useInterviewHeld = (interview: TInterview | null): boolean => {
  const isStarted = useInterviewStarted(interview?.startsAt ?? null);

  return isStarted || Boolean(interview?.completedAt);
};

export {
  useInterviewHeld,
};
